import { Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc }) => {
  // Implement the UI for the Card component according to the instructions.
  // You should be able to implement the component with the elements imported above.
  // Feel free to import other UI components from Chakra UI if you wish to.
  
  return (
    <HStack
    borderRadius="10px"
    boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
    overflow={"hidden"}
    maxWidth={"550px"}
    >
      <VStack spacing={4} p={4} alignItems="flex-start">
        <div>
          <Image 
          src={imageSrc} 
          alt={title}
          width="100%"></Image>
        </div>
        <div>
          <Heading as="h3" size="md">{title}</Heading>
        </div>
        <div>
          <Text>{description}</Text>
        </div>
        <div>
          <a href="/#projects-section"
             style={{ textDecoration: 'none', 
                      color: '#2B6CB0', 
                      fontWeight: 'bold' }}
                      >
            See more <FontAwesomeIcon icon={faArrowRight} />
          </a>
        </div>
      </VStack>
    </HStack>
  );
};

export default Card;
